import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ThemeSwitcher } from './ThemeSwitcher.jsx';

export default function Header() {
  const { pathname } = useLocation();
  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Link to="/" className="site-mark">
          <Logo />
          <span className="site-mark__name">tender-api</span>
          <span className="site-mark__tag mono">beta</span>
        </Link>
        <div style={{ flex: 1 }} />
        <nav className="site-nav">
          <NavLink to="/sample" pathname={pathname}>Live sample</NavLink>
          <NavLink to="/coverage" pathname={pathname}>Coverage</NavLink>
          <NavLink to="/pricing" pathname={pathname}>Pricing</NavLink>
          <NavLink to="/docs" pathname={pathname}>Docs</NavLink>
          <ThemeSwitcher />
          <Link to="/signup" className="site-nav__cta">
            Start <ArrowRight size={14} strokeWidth={2.5} />
          </Link>
        </nav>
      </div>
    </header>
  );
}

function NavLink({ to, pathname, children }) {
  const active = pathname === to;
  return (
    <Link
      to={to}
      className={`site-nav__link ${active ? 'is-active' : ''}`}
    >
      {children}
    </Link>
  );
}

/**
 * The omni mark: ◐  -  half-disc, the project's signature glyph. Tints
 * automatically with the theme via currentColor.
 */
function Logo() {
  return (
    <span className="site-mark__glyph" aria-hidden>
      ◐
    </span>
  );
}
